__webpack_require__.p = "/eu-assets/";